<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Tenant External Provider Management</h2>
    </div>
    <form class="needs-validation pt-1 my-2 " @submit.prevent="getTenantProviders">
      <div class=" form-group row justify-content-between m-0" >
        <div class="mx-3 my-1">

        <label class="col-form-label mr-3">Tenants</label>

          <dropdownlist
          class="my-2"
            ref="tenantDropdown"
            :data-items="tenants"
            :text-field="'name'"
            :data-item-key="'id'"
            :default-value="tenants[0]"
            @change="onSelectTenant"
          >
          </dropdownlist>
          <button
            type="submit"
            value="Search"
            class="k-button k-secondary btn mx-4 py-1"
          >
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>

        <div class="my-auto mx-auto mx-sm-2">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="tenantProviders">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left">
        </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="providerInEdit"
        :dialog-title="dialogTitle"
        :providers="providers"
        :data-item="providerInEdit"
        :selected-identity="selectedIdentity"
        :selected-tenant="selectedTenant"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "id", dir: "asc" }],
      tenantProviders: undefined,
      providerInEdit: undefined,
      providers:undefined,
      tenants: [],
      selectedIdentity: undefined,
      selectedTenant: undefined,
      tempIdentity: this.identity,
      tempTenant: undefined,
      skip: 0,
      take: 10,
      columns: [
        {
          field: "externalAuthProvider.displayName",
          title: "External Provider Name",
          width: "150px",
        },
        { field: "externalAuthProvider.fields", title: "Fields", width: "150px" },

        { field: "fieldValues", title: "Field Values", },

        { field: "externalAuthProvider.type", title: "Type",  width: "150px"},

        { cell: "myTemplate", width: "150px" },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${this.providerInEdit.id === undefined ? "Add" : "Edit"} External Provider`;
    },
    result: {
            get: function() {
                return this.tenantProviders.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.tenantProviders ? this.tenantProviders.length : 0;
    }
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if(this.tempIdentity!=null)
    {
      this.getTenants();
    }
    this.getProviders();
  },
  watch:{
    identity:function(){
      this.tempIdentity=this.identity;
      this.tempTenant = undefined;
      this.$refs.tenantDropdown.currentValue = this.tenants[0];
     this.getTenants();
    }
  },
  methods: {
    pageChangeHandler: function(event) {
            this.skip = event.page.skip;
            this.take = event.page.take;
        },
    async getTenantProviders() {
      this.selectedIdentity = this.tempIdentity;
      this.selectedTenant = this.tempTenant;
      try {
        const response = await axios.get(this.base_url + "ExternalProvider/GetTenantExternalProviders/"+this.selectedIdentity.id+"/"+this.selectedTenant.id);
        this.tenantProviders = response.data.result;
        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    async getProviders() {
      try {
        const response = await axios.get(this.base_url + "ExternalProvider/GetAllExternalProviders");
        this.providers = response.data.result;
        console.log(response.data.message);
      } catch (err) {
        console.log(err);
      }
    },
    async getTenants() {
        if(this.tempIdentity==null)
          return;
        else
        {
      try {
        const client_id = oidcSettings.client_id;
        const response = await axios.get(this.base_url + "Tenant/GetTenants/"+this.tempIdentity.id);
        this.tenants = response.data.result;
        this.tenants.unshift({id:" ",name:"No Tenant"});
        this.tempTenant=this.tenants[0];
        this.getTenantProviders();
      } catch (err) {
        console.log(err);
      }    
      }
    },
    onSelectTenant(event) {
      console.log("change", event.target.value);
      this.tempTenant = event.target.value;
    },
    edit(dataItem) {
      this.providerInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);

        const response = await axios.delete(this.base_url + "ExternalProvider/DeleteTenantExternalProvider/"+
            dataItem.externalProviderID +"/"+
            this.selectedIdentity.id +"/"+
            this.selectedTenant.id,
         );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        this.showMsg = true;
        this.userData = {};
        //this.$router.push("/home");
        this.tenantProviders = this.tenantProviders.filter((p) => p.externalProviderID !== dataItem.externalProviderID);
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async save() {
      const dataItem = this.providerInEdit;
      const isNewTenantProvider = dataItem.id === undefined;
      let data = {
        ID: dataItem.id,
        ProviderID: dataItem.externalProviderID,
        FieldValues: dataItem.fieldValues,
      };
      if (isNewTenantProvider) {
        try {
          const response = await axios
            .post(this.base_url + "ExternalProvider/AddTenantExternalProvider/"+this.selectedIdentity.id+"/"+this.selectedTenant.id,
             data);
             this.getTenantProviders();
          this.status = response.data.status;
          this.responseMsg = response.data.message;
          this.showMsg = true;
          this.userData = {};
          //this.$router.push("/home");
        } catch (err) {
          console.log("Ooops!" + err);
        }
      } else {
        try {
          //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
          const response = await axios.put(
            this.base_url + "ExternalProvider/UpdateTenantExternalProvider/"+this.selectedIdentity.id+"/"+this.selectedTenant.id,
            data,
          );
          this.status = response.data.status;
          this.responseMsg = response.data.message;
          this.showMsg = true;
          this.userData = {};
          this.getTenantProviders();
        } catch (err) {
          console.log("Ooops!" + err);
        }
      }
      this.providerInEdit = undefined;
    },
    cancel() {
      this.providerInEdit = undefined;
    },
    insert() {
      this.providerInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}

.needs-validation {
  background: white;
}
</style>